import { useEffect, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";

export default function MuteToggle() {
  const [muted, setMuted] = useState(
    () => localStorage.getItem("kks_audio_muted") === "1"
  );
  useEffect(() => {
    localStorage.setItem("kks_audio_muted", muted ? "1" : "0");
  }, [muted]);
  return (
    <button
      type="button"
      onClick={() => setMuted((v) => !v)}
      className="text-stone-500 hover:text-stone-900 p-1 rounded"
      title={muted ? "Unmute reward sounds" : "Mute reward sounds"}
      aria-label={muted ? "Unmute" : "Mute"}
      data-testid="mute-toggle"
    >
      {muted ? (
        <VolumeX className="h-4 w-4" />
      ) : (
        <Volume2 className="h-4 w-4" />
      )}
    </button>
  );
}
